import React, { useRef, useEffect, memo } from 'react'
import PropTypes from 'prop-types'
import { useAnimation } from 'framer-motion'
import { useRecoilValue } from 'recoil'
import { awardsData as awardsDataState } from '../../store/dataStore'
import CustomScroller from 'react-custom-scroller'

import { AwardsSection, AwardsWrapper, AwardsTitle } from '../../styles/awardsStyles'

import AwardsSlider from './AwardsSlider'

const Awards = ({ visible }) => {
  const awardsData = useRecoilValue(awardsDataState)

  const awardsSection = useRef(null)
  const awardsTitle = useRef(null)
  const awardsSlider = useRef(null)
  const awardsScroller = useRef(null)

  const awardsSectionVars = {
    hidden: {
      visibility: 'hidden',
      zIndex: -1,
      opacity: 0,
    },
    visible: {
      visibility: 'visible',
      zIndex: 1,
      opacity: 1,
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
        delay: 0.5,
      },
      transitionEnd: {
        visibility: 'hidden',
        zIndex: -1,
      },
    },
  }

  const awardsTitleVars = {
    hidden: {
      opacity: 0,
      x: '20%',
      transition: {
        duration: 0.75,
        delay: 0,
        ease: 'easeOut',
      },
    },
    visible: {
      opacity: 1,
      x: 0,
    },
  }

  const awardsSectionAnims = useAnimation(awardsSectionVars)
  const awardsTitleAnims = useAnimation(awardsTitleVars)

  useEffect(() => {
    if (visible) {
      awardsSectionAnims.start('visible')
      awardsTitleAnims.start('visible')
      awardsSlider.current.playVisible()
      awardsScroller.current.scrollTop = 0
    } else {
      awardsSectionAnims.start('exit')
      awardsTitleAnims.start('hidden')
      awardsSlider.current.playHidden()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <AwardsSection
      ref={awardsSection}
      initial='hidden'
      animate={awardsSectionAnims}
      variants={awardsSectionVars}
      transition={{
        opacity: {
          duration: 1,
          ease: 'linear',
        },
        default: {
          duration: 0,
          ease: 'none',
        },
      }}>
      <CustomScroller ref={awardsScroller} className='Scroller' innerClassName='ScrollerContent'>
        <AwardsWrapper>
          <AwardsTitle
            ref={awardsTitle}
            initial='hidden'
            animate={awardsTitleAnims}
            variants={awardsTitleVars}
            transition={{
              duration: 1.5,
              ease: 'easeOut',
              delay: 0.75,
            }}>
            {awardsData.title}
          </AwardsTitle>
          <AwardsSlider ref={awardsSlider} awards={awardsData.items}></AwardsSlider>
        </AwardsWrapper>
      </CustomScroller>
    </AwardsSection>
  )
}

Awards.propTypes = {
  visible: PropTypes.bool.isRequired,
}

export default memo(Awards)
